import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchOrderStatusResponse, FetchDiscountTypeResponse, FetchDiscountResponse, DiscountRow } from './../../components/logs/discount/discountLogsModule'

type CommonType =
    {
        error: string
    }

interface intialState {
    loading: boolean,
    getDiscountTypes: CommonType & { value: FetchDiscountTypeResponse | null },
    getOrderStatus: CommonType & { value: FetchOrderStatusResponse | null },
    getDiscountLogs: CommonType & {
        value: FetchDiscountResponse | null,
        // Cached paginated state
        rows: DiscountRow[],
        count: number,
        isReached: boolean,           // true when last page returned < limit rows
        filter: string | null,        // JSON fingerprint of { searchText, filterValue }
    },
}

export type discountLogsListPayload =
    {
        offset: number,
        limit: number,
        searchText: string,
        filterValue: any,
    }



const intialState: intialState =
{
    loading: true,
    getDiscountTypes: { value: null, error: '' },
    getOrderStatus: { value: null, error: '' },
    getDiscountLogs: {
        value: null,
        error: '',
        rows: [],
        count: 0,
        isReached: false,
        filter: null,
    },
}

export const getDiscountTypes = createAsyncThunk('discountLogs/getDiscountTypes', ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getDiscountTypes, { storeId: storeId })
    return HttpRoutingService.getMethod<FetchDiscountTypeResponse>(url)
})

export const getOrderStatus = createAsyncThunk('discountLogs/getOrderStatus', ({ storeId }: { storeId: Number }) => {
    const url = HttpRoutingService.replaceUrl('stores/{storeId}/preorder/status', { storeId: storeId, })
    return HttpRoutingService.getMethod<FetchOrderStatusResponse>(url, undefined, 'v1/')
})

export const getDiscountLogs = createAsyncThunk('discountLogs/getDiscountLogs', ({ storeId, data }: { storeId: number, data: discountLogsListPayload }) => {
    const url = HttpRoutingService.replaceUrl('stores/{storeId}/discounts/log', { storeId: storeId })
    return HttpRoutingService.getMethod<FetchDiscountResponse>(url, data)
})


export const discountLogsSlice = createSlice({
    name: 'discountLogs',
    initialState: intialState,
    reducers: {

    },
    extraReducers(builder) {
        builder

            .addCase(getDiscountTypes.pending, (state) => {
                state.loading = true
            })
            .addCase(getDiscountTypes.fulfilled, (state, action) => {
                state.getDiscountTypes.value = action.payload
            })
            .addCase(getDiscountTypes.rejected, (state, action) => {
                state.loading = false
                state.getDiscountTypes.error = action.error.message as string
            })

            .addCase(getOrderStatus.pending, (state) => {
                state.loading = true
            })
            .addCase(getOrderStatus.fulfilled, (state, action) => {
                state.getOrderStatus.value = action.payload
            })
            .addCase(getOrderStatus.rejected, (state, action) => {
                state.loading = false
                state.getOrderStatus.error = action.error.message as string
            })

            .addCase(getDiscountLogs.pending, (state) => {
                state.loading = true
            })
            .addCase(getDiscountLogs.fulfilled, (state, action) => {
                state.loading = false
                state.getDiscountLogs.value = action.payload

                const offset = action.meta.arg.data?.offset ?? 0
                const limit = action.meta.arg.data?.limit ?? 10
                const incoming = action.payload?.discount?.rows ?? []

                if (offset > 0) {
                    // Append paginated rows
                    state.getDiscountLogs.rows = [...state.getDiscountLogs.rows, ...incoming]
                } else {
                    // Fresh fetch — replace rows
                    state.getDiscountLogs.rows = incoming
                    state.getDiscountLogs.count = action.payload?.discount?.count ?? 0
                }

                state.getDiscountLogs.isReached = incoming.length < limit
                state.getDiscountLogs.filter = JSON.stringify({
                    searchText: action.meta.arg.data?.searchText,
                    filterValue: action.meta.arg.data?.filterValue,
                })
            })
            .addCase(getDiscountLogs.rejected, (state, action) => {
                state.loading = false
                state.getDiscountLogs.error = action.error.message as string
            })

    },
})

export default discountLogsSlice.reducer
